<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__account}">
      <el-form :inline="true" class="query-form" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.searchKey" style="width: 300px;" size="mini" placeholder="公司名称/开户行/开户行帐号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()" size="mini">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('trade:account:save')" size="mini" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
            <el-table-column prop="accountName" label="公司名称" header-align="center" align="center"></el-table-column>
            <el-table-column prop="bankName" label="开户行名称" header-align="center" align="center"></el-table-column>
            <el-table-column prop="accountNo" label="开户行账号" header-align="center" align="center"></el-table-column>
          <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('trade:account:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
<!--            <el-button v-if="$hasPermission('trade:account:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './save'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/settings/account/page',
        getDataListIsPage: true,
        deleteURL: '/settings/account',
        deleteIsBatch: true
      },
      dataForm: {
        searchKey: ''
      }
    }
  },
  components: {
    AddOrUpdate
  }
}
</script>
